import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";

export const StockinList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);
  // Header
  useEffect(() => {
    updateMainHeader("Inventory");
  }, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Stock Entry": "/stock/list" },
  ]);

  const source = {
    url: "stock-in/list",  // ✅ Fixed API path
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const
  };


  const columns: IColumns[] = [
    { header: "Date", fieldName: "CreatedDate", type: "date" },
    { header: "Item Name", fieldName: "ItemName" },
    { header: "Warehouse", fieldName: "WarehouseName" },
    { header: "Quantity", fieldName: "Quantity" },
    { header: "Purchase Price", fieldName: "PurchasePrice", type: "amount" },
    { header: "Selling Price", fieldName: "SellingPrice", type: "amount" },
    // { header: "Reference", fieldName: "ReferenceType" },
    { header: "User", fieldName: "CreatedByName" },
    { header: "Remarks", fieldName: "Remarks" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        const StockInId = row.StockInId;
        if (!StockInId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid warehouse data - missing ID", "error");
          return;
        }

        if (action === "Edit") {
          navigate(`/stockin/${StockInId}`);
          
        } else if (action === "Delete") {
          setSelectedId(StockInId);
          setPopupOpen(true);
        }
      },
    },

  ];

  // Filters (UI only)


  const handleClick = () => {
    navigate("/stockin");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="stockinGrid"
            title="Stock Entry"
            headerType="modern"
            columns={columns}
            source={source}
            exportCsv
            rowsPerPageCount={10}
            searchBox={{ searchMode: "query" }}
            addButton={{ label: "Add New Item", color: "secondary" }}
            onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>
      <ConfirmationPopup
        type="DELETE"
        apiUrl="stock-in"
        id={selectedId}
        confirmMessage="Are you sure you want to delete this stockin?"
        open={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        onConfirm={(data: any) => {
          dispatch(resetDataComponent("stockinGrid"));
          if (data.success === true) {
            showMessage(data?.message, "success");
          } else {
            showMessage(data?.detail, "error");
          }
        }}
      />
    </Grid>
  );
};